import React from 'react';
import { ScrollText } from 'lucide-react';
import Avatar from './Avatar';
import { relativeDay } from '../utils/relativeDay';

const HistoryFeed = ({ logs, onSelectLog }) => {
  return (
    <div className="mt-8 border-t border-white/10 pt-6">
      <h2 className="text-lg font-bold text-ink-fg mb-4 flex items-center gap-2">
        <ScrollText size={18} className="text-ink-fg/40" /> Recent Activity
      </h2>
      <div className="space-y-3 max-h-64 overflow-y-auto pr-2 custom-scrollbar">
        {logs.length === 0 ? (
          <p className="text-ink-fg/40 italic text-sm text-center py-4">No chores done yet today...</p>
        ) : (
          logs.map((log) => (
            <div
              key={log.id}
              onClick={() => onSelectLog(log)}
              className="flex items-center gap-3 bg-ink-card p-4 rounded-2xl border border-white/10 shadow-sm cursor-pointer hover:shadow-md hover:border-mint/25 transition-all duration-200"
            >
              <Avatar user={log.user?.[0]} imgBorder="border border-white/10" />
              <div className="min-w-0 flex-1">
                <p className="font-medium text-ink-fg text-sm truncate">"{log.choreTitle}"</p>
                <p className="text-xs text-ink-fg/50 truncate mt-0.5">
                  <span className="font-semibold text-ink-fg/70">
                    {log.user?.length > 0 ? log.user.map(u => u.name).join(', ') : 'Someone'}
                  </span>
                  <span className="text-ink-fg/30"> · </span>
                  {relativeDay(log.doneAt)}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HistoryFeed;
